import { useEffect, useMemo, useState } from 'react';
import useSWR from 'swr';

export default function useIframe() {
  const [isIframe, setIframe] = useState(false);
  const { data } = useSWR('global://window-message');
  const user: {
    accessToken?: string;
    name?: string;
    [key: string]: any;
  } | null = useMemo(() => {
    if (!data || !data.user) {
      return null;
    }
    return data.user;
  }, [data]);

  useEffect(() => {
    const init = () => {
      setIframe(() => window.self !== window.top);
    };

    init();
  }, []);

  return {
    isIframe,
    user: isIframe ? { ...user } : null,
    chatAssistant: data?.chatAssistant,
  };
}
